// eslint-disable-next-line
export function validStep(propValue, key, componentName, location, propFullName) {
  if (!Object.getOwnPropertyNames(propValue[key]).includes('validationSchema')) {
    return new Error(
      `${propFullName} does not have a validationSchema function.
      All form steps must contain both validationSchema and submitHandler functions`,
    );
  }

  if (!Object.getOwnPropertyNames(propValue[key]).includes('submitHandler')) {
    return new Error(
      `${propFullName} does not have a submitHandler function.
      All form steps must contain both validationSchema and submitHandler functions`,
    );
  }
  return null;
}
